export const customChartUpgraderFn = (customVisualProps, renderPropElements) => {
    const { columnVisualProps, axisVisualProps, dataLabelVisualProps, legendVisualProps, tooltipVisualProps, displayVisualProps, ...otherProps } = customVisualProps;
    const newColumnProperties = columnVisualProps || {};
    const newAxisProperties = axisVisualProps || {};
    const newDataLabelProperties = dataLabelVisualProps || {};
    const newLegendProperties = legendVisualProps || {};
    const newTooltipProperties = tooltipVisualProps || {};
    const newDisplayProperties = (renderPropElements ? otherProps : displayVisualProps) || {};
    return {
        columnProperties: newColumnProperties,
        axisProperties: newAxisProperties,
        dataLabelProperties: newDataLabelProperties,
        tooltipProperties: newTooltipProperties,
        legendProperties: newLegendProperties,
        displayProperties: newDisplayProperties,
    };
};
export const customChartDowngraderFn = (clientStateV5, renderPropElements) => {
    let customVisualProps = {
        columnVisualProps: {},
        displayVisualProps: {},
        dataLabelVisualProps: {},
        legendVisualProps: {},
        axisVisualProps: {},
        tooltipVisualProps: {},
    };
    customVisualProps.columnVisualProps = clientStateV5.columnProperties;
    customVisualProps.axisVisualProps = clientStateV5.axisProperties;
    customVisualProps.dataLabelVisualProps = clientStateV5.dataLabelProperties;
    customVisualProps.legendVisualProps = clientStateV5.legendProperties;
    customVisualProps.tooltipVisualProps = clientStateV5.tooltipProperties;
    if (renderPropElements) {
        customVisualProps = {
            ...customVisualProps,
            ...clientStateV5.displayProperties,
        };
    }
    else {
        customVisualProps.displayVisualProps = clientStateV5.displayProperties;
    }
    return customVisualProps;
};
//# sourceMappingURL=customVisual-to-v5.js.map